import { FilterGroupNodeWithId, FilterTreeNodeWithId } from "../types/common";
import { FilterGroupNode, FilterTreeNode } from "@/services/cloudchipr.api";

export const isTreeNodeWithIdFilterGroup = (
  filter?: FilterTreeNodeWithId | FilterTreeNode | null,
): filter is FilterGroupNodeWithId => {
  return filter?.node_type === "group";
};

export const isTreeNodeFilterGroup = (
  filter?: FilterTreeNodeWithId | FilterTreeNode | null,
): filter is FilterGroupNode => {
  return filter?.node_type === "group";
};
